const options = {
  5: "bg-neutral-700/5",
  10: "bg-neutral-700/10",
  25: "bg-neutral-700/25",
  50: "bg-neutral-700/50",
  75: "bg-neutral-700/75",
  90: "bg-neutral-700/90",
  100: "bg-neutral-700",
};

const from = {
  5: "from-neutral-700/5",
  10: "from-neutral-700/10",
  25: "from-neutral-700/25",
  50: "from-neutral-700/50",
  75: "from-neutral-700/75",
  90: "from-neutral-700/90",
  100: "from-neutral-700",
};

export default function getBackgroundNeutral700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
